// eslint-disable-next-line import/no-anonymous-default-export
export default {

  SECTION_a: "General Information",
  SECTION_b: "Quality & Quantity Assessment of Served Food",
  SECTION_c: "Water Supply & Quality Checking",
  SECTION_d: "Kitchen Space",
  SECTION_e: "Safety Arrangements",
  SECTION_f: "Sanitation and Cleanliness",
  SECTION_g: "Waste Management",
  SECTION_h: "Personal Hygiene",
  SECTION_i: "Food Hygiene",
  SECTION_j: "IEC & Monitoring",
  SECTION_k: "Challenges & Suggestion",

  // Section A — General Information
  A1: "Whether Kitchen remains functional everyday including on holidays. If NO, specify the reason in the remark coloumn for non functioning everyday.",
  A2: "Whether kitchen is operated by SHGs or others. If others, mention in the remark coloumn who are operating and specify the reason for non-engagement of SHGs.",
  A3: "Mention the number of Cook Cum Helpers engaged in the functioning of kitchen",
  A4: "Timeline for kitchen functional",
  A5: "Indicate the average number of beneficiaries for whom food is prepared.",

  // Section B — Quality & Quantity Assessment of Served Food
  B1: "How would you rate the quality of raw materials and vegetables used for cooking?",
  B2: "How would you rate the quantity of the meal served?",
  B3: "Are all specified items ( ie. Rice, Dal, Sabji and One full Tabled egg) being cooked everyday",

  // Section C — Water Supply & Quality Checking
  C1: "Is there an adequate water storage capacity in canteen (>=45 L per head/day) for 2 days",
  C2: "Is a water filter installed to ensure safe drinking water for kitchen staff ?",
  C3: "Are overhead/underground water tanks cleaned in every six months, with records maintained?",
  C3_HELPER: "Please mention the last date of tank cleaning and upload the picture of the tank cleaning with date printed",
  C4: "Is chemical and bacteriological testing of water conducted in every six months, with records maintained?",
  C4_HELPER: "Please mention the last date of the water quality testing and upload the corresponding test report",

  // Section D — Kitchen Space
  "D.1": "Is the open kitchen adequately covered on all sides and have an overhead shed to prevent the entry of dirt, dust, and pests?",
  "D.2": "Does the kitchen have properly constructed slabs or platforms for cooking?",
  "D.3": "Is there a functional sink inside the kitchen area for canteen staff?",
  "D.3_HELPER" : "Functional sink must have running water, soap for handwash, proper tap, proper outlet pipe and connected to a drainage system. [If all the above conditions are available, respond YES]",
  "D.4": "Is the kitchen well-ventilated, with a properly installed and functional exhaust fan?",
  "D.5": "Is there a schedule for periodic deep cleaning of the entire kitchen and recorded in housekeeping checklist? (Deep cleaning is needed weekly that includes cleaning of kitchen wall tiles/slabs, ceiling, cobweb, doors and window cleaning and furniture cleaning etc.). If record is maintained and updated daily, assign YES",
  "D.5_HELPER" : "(Deep cleaning is needed weekly that includes cleaning of kitchen wall tiles/slabs, ceiling, cobweb, doors and window cleaning and furniture cleaning etc.). If record is maintained and updated daily, assign YES",
  "D.6": "Is the store area for raw materials (rice, vegetables, etc.) properly maintained, deep cleaned and recorded in housekeeping checklist? (Deep cleaning of store room is needed every week. If housekeeping checklist maintained and updated daily, assign YES",
  "D.6_HELPER": "Upload the current month's housekeeping record for verification",
  "D.7": "Is LPG used as the primary fuel for cooking? Please be ensured that no smoke chulha is used inside the kitchen?",
  "D.8": "How would you rate the overall cleanliness of the kitchen area",

  // Section E — Safety Arrangements
  "E.1": "Is a fire extinguisher installed and functional in the kitchen?",
  "E.2": "Does the first-aid box contain essential items such as disinfectants for cuts and burns, along with other necessary medicines required for addressing kitchen-related injuries? (* Check the expiry dates of all medicines)",
  "E.3": "Are all staff trained on fire safety & mock drills?",

  // Section F — Sanitation and Cleanliness
  "F.1": "Is there a functional toilet for kitchen staff?",
  "F.1_HELPER": "Functionality of toilet means availability of running water for flushing and cleaning, non-choking toilet pans and urinals, functional cisterns, washbasin with soap and water for handwash and proper drainage system",
  "F.2": "Are the toilets well ventilated, illuminated and maintain privacy?",
  "F.3": "Are the toilets cleaned everyday and recorded in housekeeping checklist?",
  "F.3_HELPER": "Upload the current month's housekeeping record for verification",
  "F.4": "Is there a covered dustbin in staff's toilet for disposal of sanitary waste?.",
  "F.4_HELPER": "Upload a picture of the dustbin inside the toilet",
  "F.5": "Is there a covered drainage system around kitchen area?",
  "F.6": "Are the cleaning materials (mopping cloth, broom, duster, wiper etc.) not stored in toilets?",
  "F.7": "Does the staff cleans the cooking area before and after use and uses 2-bucket system with disinfectant (phenyl/lizol etc) for floor mopping?",
  "F.7_HELPER": "Upload a picture of the cleaning staff using 2 bucket system for floor mopping",
  "F.8": "Are regular pest control measures (every 3-4 months) conducted in the kitchen and store area? (Check and verify pest control record)",
  "F.8_HELPER": "Mention the last date of pest control activity and upload the record for verification",

  // Section G — Waste Management
  "G.1": "Waste segregation system (dry & wet waste) at all points along with covered, foot-operated bins",
  "G.2": "Whether IEC on waste segregation is displayed near the waste bins?",
  "G.2_HELPER": "Upload the picture for verification",
  "G.3": "Waste bins cleaned everyday after emptying the waste and recorded in housekeeping checklist. ",
  "G.3_HELPER": "Check the housekeeping checklist, if record is up to date, assign YES",

  // Section H — Personal Hygiene
  "H.1": "Do the staff should wear appropriate protective gear in canteen? i. apron and cap while cutting vegetables & washing utensils ii. apron, cap and mask while cooking iii. apron, cap, mask and food handling gloves during packaging food iv. apron and utility gloves while cleaning and mopping kitchen and its surroundings",
  "H.1_HELPER": "Upload the picture of staff wearing PPE while doing activities.",
  "H.2": "Are the staff trained & practice 6 steps of handwashing? (* Observe the 6 steps of hand washing)",
  "H.3": "Are half-yearly health check-ups conducted for the staff, and are the records properly maintained? (Half yearly health check-ups for staff and maintain record)",
  "H.3_HELPER": "Mention the last date of health check-up and upload the records for verification",
  "H.4": "Do the staff maintain personal hygiene (no nail polish, trimmed nails, covered hair, etc.)",

  // Section I — Food Hygiene
  "I.1": "What type of packaging materials used for packaging food to the beneficiaries?",

  // Section J — IEC & Monitoring
  "J.1": "Are the posters on handwashing, safe toilet use, etc. displayed in the kitchen?",

  // Section K — Challenges & Suggestion
  challenges: "Challenges (If Any)",
  suggestions: "Suggestions (If Any)",
};